import { ModuleWithProviders, NgModule } from '@angular/core';

import { TrackingSandbox } from './sandboxes/tracking.sandbox.service';
import { GoogleAnalyticsService } from './services/google-analytics/google-analytics.service';

@NgModule({
    providers: [GoogleAnalyticsService]
})
export class TrackingModule {
    static forRoot(): ModuleWithProviders<TrackingModule> {
        return {
            ngModule: TrackingModule,
            providers: [TrackingSandbox]
        };
    }
}

export { TrackingProvider } from './entities/tracking-provider.entity';
export { TrackingSandbox } from './sandboxes/tracking.sandbox.service';
export { TrackingProviderService } from './services/_base-tracking-provider.service';
export { GoogleAnalyticsService } from './services/google-analytics/google-analytics.service';
